const MESSAGES: { [key: string]: string } = {
  AUTH_CODE_INVALID: 'Please enter a valid 5-digit code',
  AUTH_CODE_NOT_FOUND: 'The code entered was not found',
  INVALID_EMAIL: 'Please enter a valid email address',
  SIGNIN_CONFIRM: 'We\'ve sent a login link to your email. You can enter the login code below to continue this session or follow the link in the email',
  UNKNOWN_ERROR: 'An unexpected error happened. Please try again',
};

export {
  MESSAGES,
};
